import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form, Button, Table, Alert, Pagination } from 'react-bootstrap';
import { format } from 'date-fns';
import api from '../../Api/apiAxios';
import styles from './LogAuditoriaIndex.module.css';

export default function LogAuditoriaIndex() {
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filtrosForm, setFiltrosForm] = useState({
        nomeUsuario: '',
        tabela: '',
        acao: '',
        dataInicio: '',
        dataFim: '',
        registroId: ''
    });
    const [filtrosAplicados, setFiltrosAplicados] = useState({
        nomeUsuario: '',
        tabela: '',
        acao: '',
        dataInicio: '',
        dataFim: '',
        registroId: ''
    });
    const [pagina, setPagina] = useState(1);
    const [totalPaginas, setTotalPaginas] = useState(1);
    const [total, setTotal] = useState(0);
    const itensPorPagina = 50;

    const carregarLogs = React.useCallback(async () => {
        setLoading(true);
        try {
            const params = new URLSearchParams({
                pagina: pagina.toString(),
                itensPorPagina: itensPorPagina.toString()
            });

            if (filtrosAplicados.nomeUsuario) params.append('nomeUsuario', filtrosAplicados.nomeUsuario);
            if (filtrosAplicados.tabela) params.append('tabela', filtrosAplicados.tabela);
            if (filtrosAplicados.acao) params.append('acao', filtrosAplicados.acao);
            if (filtrosAplicados.dataInicio) params.append('dataInicio', filtrosAplicados.dataInicio);
            if (filtrosAplicados.dataFim) params.append('dataFim', filtrosAplicados.dataFim);
            if (filtrosAplicados.registroId) params.append('registroId', filtrosAplicados.registroId);

            const response = await api.get(`/LogAuditoria?${params.toString()}`);
            setLogs(response.data.logs || []);
            setTotalPaginas(response.data.totalPaginas || 1);
            setTotal(response.data.total || 0);
        } catch (error) {
            console.error('Erro ao carregar logs:', error);
        } finally {
            setLoading(false);
        }
    }, [pagina, itensPorPagina, filtrosAplicados]);

    useEffect(() => {
        carregarLogs();
    }, [carregarLogs]);

    function handleFiltroChange(e) {
        const { name, value } = e.target;
        setFiltrosForm(prev => ({ ...prev, [name]: value }));
    }

    function aplicarFiltros() {
        setPagina(1);
        setFiltrosAplicados({ ...filtrosForm });
    }

    function limparFiltros() {
        const limpo = {
            nomeUsuario: '',
            tabela: '',
            acao: '',
            dataInicio: '',
            dataFim: '',
            registroId: ''
        };
        setFiltrosForm(limpo);
        setFiltrosAplicados(limpo);
        setPagina(1);
    }

    function getAcaoLabel(acao) {
        switch (acao) {
            case 1: return 'Incluir';
            case 2: return 'Alterar';
            case 3: return 'Excluir';
            default: return 'Desconhecido';
        }
    }

    function getAcaoBadgeClass(acao) {
        switch (acao) {
            case 1: return 'success';
            case 2: return 'warning';
            case 3: return 'danger';
            default: return 'secondary';
        }
    }

    return (
        <Container fluid className={styles.container}>
            <Row className="mb-4">
                <Col>
                    <p className="text-muted">Log de Auditoria</p>
                    <h2>Ações em Pedidos, Contratos e Faturamentos</h2>
                </Col>
            </Row>

            <Row className="mb-3">
                <Col md={12}>
                    <Form className={styles.filtros}>
                        <Row>
                            <Col md={2}>
                                <Form.Group>
                                    <Form.Label>Nome do Funcionário</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="nomeUsuario"
                                        value={filtrosForm.nomeUsuario}
                                        onChange={handleFiltroChange}
                                        placeholder="Nome"
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={2}>
                                <Form.Group>
                                    <Form.Label>Tabela</Form.Label>
                                    <Form.Select
                                        name="tabela"
                                        value={filtrosForm.tabela}
                                        onChange={handleFiltroChange}
                                    >
                                        <option value="">Todas</option>
                                        <option value="Contratos">Contratos</option>
                                        <option value="Pedidos">Pedidos</option>
                                        <option value="Faturamentos">Faturamentos</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col md={2}>
                                <Form.Group>
                                    <Form.Label>Ação</Form.Label>
                                    <Form.Select
                                        name="acao"
                                        value={filtrosForm.acao}
                                        onChange={handleFiltroChange}
                                    >
                                        <option value="">Todas</option>
                                        <option value="1">Incluir</option>
                                        <option value="2">Alterar</option>
                                        <option value="3">Excluir</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col md={2}>
                                <Form.Group>
                                    <Form.Label>Data Início</Form.Label>
                                    <Form.Control
                                        type="date"
                                        name="dataInicio"
                                        value={filtrosForm.dataInicio}
                                        onChange={handleFiltroChange}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={2}>
                                <Form.Group>
                                    <Form.Label>Data Fim</Form.Label>
                                    <Form.Control
                                        type="date"
                                        name="dataFim"
                                        value={filtrosForm.dataFim}
                                        onChange={handleFiltroChange}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={2}>
                                <Form.Group>
                                    <Form.Label>Registro ID</Form.Label>
                                    <Form.Control
                                        type="number"
                                        name="registroId"
                                        value={filtrosForm.registroId}
                                        onChange={handleFiltroChange}
                                        placeholder="ID do registro"
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row className="mt-2">
                            <Col>
                                <Button variant="primary" onClick={aplicarFiltros} disabled={loading}>
                                    {loading ? 'Carregando...' : 'Filtrar'}
                                </Button>
                                <Button variant="secondary" onClick={limparFiltros} className="ms-2">
                                    Limpar
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row>

            <Row>
                <Col>
                    <Alert variant="info">
                        Total de registros: <strong>{total}</strong> | Página {pagina} de {totalPaginas}
                    </Alert>
                </Col>
            </Row>

            <Row>
                <Col>
                    <Table striped bordered hover responsive>
                        <thead>
                            <tr>
                                <th>Data/Hora</th>
                                <th>Usuário</th>
                                <th>Ação</th>
                                <th>Tabela</th>
                                <th>Registro ID</th>
                                <th>Campo</th>
                                <th>Conteúdo Anterior</th>
                                <th>Conteúdo Novo</th>
                                <th>Observações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan={9} className="text-center">
                                        <div className="spinner-border" role="status">
                                            <span className="visually-hidden">Carregando...</span>
                                        </div>
                                    </td>
                                </tr>
                            ) : logs.length === 0 ? (
                                <tr>
                                    <td colSpan={9} className="text-center text-muted">
                                        Nenhum log encontrado
                                    </td>
                                </tr>
                            ) : (
                                logs.map((log) => (
                                    <tr key={log.id}>
                                        <td>
                                            {log.dataHora
                                                ? format(new Date(log.dataHora), 'dd/MM/yyyy HH:mm:ss')
                                                : '-'}
                                        </td>
                                        <td>
                                            <div>
                                                <strong>{log.nomeUsuario || 'N/A'}</strong>
                                                <br />
                                                <small className="text-muted">ID: {log.usuarioId}</small>
                                            </div>
                                        </td>
                                        <td>
                                            <span className={`badge bg-${getAcaoBadgeClass(log.acao)}`}>
                                                {getAcaoLabel(log.acao)}
                                            </span>
                                        </td>
                                        <td>{log.tabela || '-'}</td>
                                        <td>{log.registroId || '-'}</td>
                                        <td>{log.campo || '-'}</td>
                                        <td>
                                            <div className={styles.conteudoCampo}>
                                                {log.conteudoAnterior || '-'}
                                            </div>
                                        </td>
                                        <td>
                                            <div className={styles.conteudoCampo}>
                                                {log.conteudoNovo || '-'}
                                            </div>
                                        </td>
                                        <td>
                                            <div className={styles.observacoes}>
                                                {log.observacoes || '-'}
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </Table>
                </Col>
            </Row>

            {totalPaginas > 1 && (
                <Row className="mt-3">
                    <Col className="d-flex justify-content-center">
                        <Pagination>
                            <Pagination.First
                                onClick={() => setPagina(1)}
                                disabled={pagina === 1}
                            />
                            <Pagination.Prev
                                onClick={() => setPagina(p => Math.max(1, p - 1))}
                                disabled={pagina === 1}
                            />
                            {[...Array(Math.min(5, totalPaginas))].map((_, i) => {
                                const pageNum = Math.max(1, Math.min(totalPaginas - 4, pagina - 2)) + i;
                                if (pageNum > totalPaginas) return null;
                                return (
                                    <Pagination.Item
                                        key={pageNum}
                                        active={pageNum === pagina}
                                        onClick={() => setPagina(pageNum)}
                                    >
                                        {pageNum}
                                    </Pagination.Item>
                                );
                            })}
                            <Pagination.Next
                                onClick={() => setPagina(p => Math.min(totalPaginas, p + 1))}
                                disabled={pagina === totalPaginas}
                            />
                            <Pagination.Last
                                onClick={() => setPagina(totalPaginas)}
                                disabled={pagina === totalPaginas}
                            />
                        </Pagination>
                    </Col>
                </Row>
            )}
        </Container>
    );
}
